/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardImg,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components

function SectionProject() {
  return (
    <>
      <div className="section section-project cd-section" id="projects" style={{ paddingTop: "40px", paddingBottom: "0" }}>
        {/* ********* PROJECTS 3 ********* */}
        <div className="projects-3" id="projects-3" style={{ paddingTop: "0", paddingBottom: "0" }}>
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <div className="space-top" />
                <h2 style={{ color: "#000000", marginTop: "30px", marginBottom: "25px", minHeight: "32px" }}>
                  Our Services
                </h2>
                <h6 style={{ color: "#000000", marginTop: "30px", marginBottom: "25px", minHeight: "32px" }}>
                  Some of our various services
                </h6>
              </Col>
            </Row>
            <Row style={{ paddingBottom: "50px" }}>
              <Col md="4">
                <Card className="card-profile card-plain" style={{ marginTop: "50px" }}>
                  <CardImg top tag="div">
                    <img
                      alt="..."
                      className="img"
                      src={require("assets/img/landing/wedding.jpg")}
                    />
                  </CardImg>
                  <CardBody>
                    {/* <h6 className="card-category">Weddings</h6> */}
                    <CardTitle tag="h4">
                      <b>
                        Weddings
                      </b>
                    </CardTitle>
                    <p className="card-description">
                      <b>
                        The day you have been waiting for
                      </b>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card className="card-profile card-plain" style={{ marginTop: "50px" }}>
                  <CardImg top tag="div">
                    <img
                      alt="..."
                      className="img"
                      src={require("assets/img/landing/conference.jpg")}
                    />
                  </CardImg>
                  <CardBody>
                    {/* <h6 className="card-category">Conference</h6> */}
                    <CardTitle tag="h4">
                      <b>
                        Conference
                      </b>
                    </CardTitle>
                    <p className="card-description">
                      <b>
                        All kind of conferences
                      </b>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card className="card-profile card-plain" style={{ marginTop: "50px" }}>
                  <CardImg top tag="div">
                    <img
                      alt="..."
                      className="img"
                      src={require("assets/img/landing/event.jpg")}
                    />
                  </CardImg>
                  <CardBody>
                    {/* <h6 className="card-category">Events</h6> */}
                    <CardTitle tag="h4">
                      <b>
                        Events
                      </b>
                    </CardTitle>
                    <p className="card-description">
                      <b>
                        We can do variety of events..
                      </b>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col></Col>
              <Col className="text-center">
                <Button
                  className="btn-round"
                  color="danger"
                  type="button"
                  to="/portfolio"
                  tag={Link}
                  outline
                >
                  Check our services -{'>'}
                </Button>
              </Col>
              <Col></Col>
            </Row>
          </Container>
          {/* ********* END PROJECTS 3 ********* */}
          {/* ********* PROJECTS 4 ********* */}
          <div className="project-4 section section-dark">
            <Container>
              <Row>
                <Col className="ml-auto mr-auto text-center" md="8">
                  <h2 className="title">Some of Our Awesome Projects</h2>
                  <h5 className="description">
                    Over the years, we have planned and executed our projects successfully.
                    Scroll and browse through some of our astonoshing previous projects.
                  </h5>
                </Col>
              </Row>
              <div className="space-top" />
              <Row>
                <Col className="ml-auto" md="5">
                  <Card
                    data-background="image"
                    style={{
                      backgroundImage:
                        "url(" +
                        require("assets/img/landing/event1.jpg") +
                        ")",
                    }}
                  >
                  </Card>
                </Col>
                <Col className="mr-auto" md="5">
                  <Card className="card-plain">
                    <CardBody>
                      <h6 className="card-category">Red Bull</h6>
                      <CardTitle tag="h3">
                        Red Bull Back2Back 2018
                        </CardTitle>
                      <p className="card-description">
                        An electronic-Sport that was held in 2018 for players competing offline in a 2 VS 2 match.
                        This was played on Play Station 4 console and was aimed towards a schematic, communicative and team adaptive skill to win.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <br />
              <hr />
              <br />
              <Row>
                <Col className="ml-auto" md="5">
                  <Card className="card-plain">
                    <CardBody>
                      <h6 className="card-category">National Day</h6>
                      <CardTitle tag="h3">
                        Qatar National Sports Day
                        </CardTitle>
                      <p className="card-description">
                        The Qatar National Sports Day is held every year on February 9th. Many youngster and adults take part in various sports activities.
                        Smart Event and Production has dedicated their services in numerous sports day projects and events.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
                <Col className="mr-auto" md="5">
                  <Card
                    data-background="image"
                    style={{
                      backgroundImage:
                        "url(" +
                        require("assets/img/landing/event2.jpeg") +
                        ")",
                    }}
                  >
                  </Card>
                </Col>
              </Row>
              <br />
              <hr />
              <br />
              <Row>
                <Col className="ml-auto" md="5">
                  <Card
                    data-background="image"
                    style={{
                      backgroundImage:
                        "url(" +
                        require("assets/img/landing/event3.jpg") +
                        ")",
                    }}
                  >
                  </Card>
                </Col>
                <Col className="mr-auto" md="5">
                  <Card className="card-plain">
                    <CardBody>
                      <h6 className="card-category">Sports DAY</h6>
                      <CardTitle tag="h3">
                        Qatar Social work Sports DAY 2018 / Neymar Jr's Five 2018
                        </CardTitle>
                      <p className="card-description">
                        Neymar Jr's Five event took place on the year 2018 where in teams of five the players competed for the trophy but with a twist every time a player scores the opponent looses a player.
                        We feel extremely priviliged to work with REDBULL on this project and contribute towards the greater good and success.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <br />
              <hr />
              <br />
              <Row>
                <Col className="ml-auto" md="5">
                  <Card className="card-plain">
                    <CardBody>
                      <h6 className="card-category">Red Bull</h6>
                      <CardTitle tag="h3">
                        Red Bull CPD 2018
                        </CardTitle>
                      <p className="card-description">
                        Red Bull Car Park Drift was a call out for all the sport drift car lovers. An underground drift event that took place along the early days of 2018.
                        Smart Event and Production were part of the execution team on delivering the best service towards the event which took place in the Lusail Circuit Sports Club.
                      </p>
                    </CardBody>
                  </Card>
                </Col>
                <Col className="mr-auto" md="5">
                  <Card
                    data-background="image"
                    style={{
                      backgroundImage:
                        "url(" +
                        require("assets/img/landing/event4.jpg") +
                        ")",
                    }}
                  >
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        {/* ********* END PROJECTS 4 ********* */}
      </div>
    </>
  );
}

export default SectionProject;
